import { tagTypes } from '@constants/element-types.const'
import './Tag.scss'
import classNames from 'classnames'

interface TagProps {
  type: typeof tagTypes.CARD | typeof tagTypes.STEP
  label: string
}

const Tag = ({ label, type }: TagProps) => {
  return <div className={classNames('tag', type)}>{label}</div>
}

export default Tag
